import resolveTailwindClasses from '../utils/resolveTailwindClasses'
import { Typography, TypographyProps, WeightTextType } from '.'

type Props = Omit<TypographyProps, 'variant'> & {
  size?: BodyTextSizeType
  htmlFor?: string
}
type BodyTextSizeType = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl'

const sizeToStyle: Record<BodyTextSizeType, React.ComponentProps<'p'>['className']> = {
  '3xl': 'text-2xl', // 24px
  '2xl': 'text-xl', // 20px,
  xl: 'text-lg ', // 18px
  lg: 'text-base ', // 16px
  md: 'text-sm', // 14px
  sm: 'text-xs', // 12px,
  xs: 'text-[0.625rem] leading-4' // 10px
}

const weightToStyle: Record<WeightTextType, React.ComponentProps<'p'>['className']> = {
  heavy: 'font-extrabold',
  bold: 'font-bold',
  semibold: 'font-[634]',
  regular: 'font-[412]',
  light: 'font-light'
}

/**
 * @group Components
 * @category Atoms
 */
export const Body = ({ className, weight = 'regular', size = 'md', Component = 'p', children, ...props }: Props) => {
  const sizeStyle = sizeToStyle[size]
  const weightStyle = weightToStyle[weight]

  return (
    <Typography Component={Component} className={resolveTailwindClasses(sizeStyle, weightStyle, className)} {...props}>
      {children}
    </Typography>
  )
}
